import baseTheme, { colors } from 'style/theme';

export const ukraineColors = {
  primaryText: colors.black,

  // links
  primaryLink: {
    default: colors.black,
    hover: colors.turquoise
  },

  // buttons
  primaryButton: {
    default: colors.yellow,
    hover: '#FFDF74',
    active: '#FFEBAA',
    text: colors.black
  },

  secondaryButton: {
    default: colors.black,
    hover: '#385264',
    active: '#627886',
    text: colors.white
  }
};

const theme = {
  ...baseTheme,
  colors: {
    ...colors,
    ...ukraineColors
  }
};

export default theme;
